import React, { Component } from "react";
import { ProgressBar } from "react-bootstrap";
class Skills extends Component {
  render() {
    return (
      <section id="skills" className="skills section-bg">
        <div className="container">
          <div className="section-title">
            <h2>Skills</h2>
            {/* <p>
              Magnam dolores commodi suscipit. Necessitatibus eius consequatur
              ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam
              quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea.
              Quia fugiat sit in iste officiis commodi quidem hic quas.
            </p> */}
          </div>

          <div className="row skills-content">
            <div className="col-lg-6" data-aos="fade-up">
              {/* CPP */}
              <div className="progress">
                <span className="skill">
                  CPP <i className="val">80%</i>
                </span>
                <div className="progress-bar-wrap">
                  <ProgressBar animated now={80} />
                </div>
              </div>
              {/* HTML */}
              <div className="progress">
                <span className="skill">
                  HTML <i className="val">100%</i>
                </span>
                <div className="progress-bar-wrap">
                  <ProgressBar animated now={100} />
                </div>
              </div>
              {/* CSS */}
              <div className="progress">
                <span className="skill">
                  .Net Core <i className="val">80%</i>
                </span>
                <div className="progress-bar-wrap">
                  <ProgressBar animated now={90} />
                </div>
              </div>
              {/* React */}
              <div className="progress">
                <span className="skill">
                React <i className="val">60%</i>
                </span>
                <div className="progress-bar-wrap">
                  <ProgressBar animated now={60} />
                </div>
              </div>
            </div>

            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
              {/* C# */}
              <div className="progress">
                <span className="skill">
                  C# <i className="val">80%</i>
                </span>
                <div className="progress-bar-wrap">
                  <ProgressBar animated now={80} />
                </div>
              </div>
              {/* CSS */}
              <div className="progress">
                <span className="skill">
                  CSS <i className="val">90%</i>
                </span>
                <div className="progress-bar-wrap">
                  <ProgressBar animated now={90} />
                </div>
              </div>
              {/* Ionic */}
              <div className="progress">
                <span className="skill">
                  Ionic  <i className="val">75%</i>
                </span>
                <div className="progress-bar-wrap">
                  <ProgressBar animated now={75} />
                </div>
              </div>
              {/* Angular */}
              <div className="progress">
                <span className="skill">
                  Angular  <i className="val">85%</i>
                </span>
                <div className="progress-bar-wrap">
                  <ProgressBar animated now={85} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Skills;
